import { Grid } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';

import { gridSizeMdLg6, useTabsFormOnly } from '@/shared';
import { CustomTextField, TabTextLabel } from '@/shared/components/ui';
import type { Contrato } from '@/shared/interfaces';
import ContractStateChip from '../ContractStateChip';
import ClienteFibraBtnsServiceContract from './ClienteFibraBtnsServiceContract';
import type { ClienteFibraSummaryFormType } from './SaveContractFibra';
import {
  ClienteInfoSummaryFormPart,
} from './parts';

export type ClienteFibraSummaryTFormabProps = {
  contract: Contrato;

  form: UseFormReturn<ClienteFibraSummaryFormType>;
};

const ClienteFibraSummaryTFormab: React.FC<ClienteFibraSummaryTFormabProps> = ({
  contract,
  form,
}) => {
  ///* hooks -------------------------
  const { handleMethodChange, valueTab } = useTabsFormOnly();

  ///* form -------------------------
  const { errors } = form.formState;

  return (
    <>
      {/* ============ top bar - plan options ============ */}
      <>
        <Grid
          item
          container
          xs={12}
          spacing={2}
          pb={2}
          mt={1}
          justifyContent="center"
          alignItems="start"
        >
          <Grid item xs={12} md={6}>
            <TabTextLabel
              text="ESTADO DEL SERVICIO: "
              variant="subtitle2"
              uppercase={false}
              pb={1}
              pl={0}
              color="#343a40c2"
            />
            <ContractStateChip contract={contract} widthChip="60%" />
          </Grid>

          <ClienteFibraBtnsServiceContract contract={contract} />
        </Grid>
      </>

      {/* ===================== Cliente Info ===================== */}
      <ClienteInfoSummaryFormPart
        contract={contract}
        handleMethodChange={handleMethodChange}
        valueTab={valueTab}
      />

      {/* ===================== Contract Info ===================== */}
      <TabTextLabel text="Datos del Contrato" pt="57px" />
      <>
        <CustomTextField
          name="planLabel"
          label="Plan"
          control={form.control}
          defaultValue={form.getValues().planLabel || ''}
          error={errors.planLabel}
          helperText={errors.planLabel?.message?.toString() ?? ''}
          shrink
          disabled
        />

        <CustomTextField
          label="Tipo de Contrato"
          name="tipo_servicio"
          control={form.control}
          defaultValue={form.getValues().tipo_servicio || ''}
          error={errors.tipo_servicio}
          helperText={errors.tipo_servicio?.message}
          shrink
          type="tipo_servicio"
          disabled
          size={gridSizeMdLg6}
        />
        <CustomTextField
          label="Permanencia"
          name="permanencia"
          control={form.control}
          defaultValue={form.getValues().permanencia || ''}
          error={errors.permanencia}
          helperText={errors.permanencia?.message}
          shrink
          type="permanencia"
          disabled
          size={gridSizeMdLg6}
        />

        <CustomTextField
          name="numero_contrato"
          label="No. Contrato"
          control={form.control}
          defaultValue={form.getValues().numero_contrato || ''}
          error={errors.numero_contrato}
          helperText={errors.numero_contrato?.message?.toString() ?? ''}
          shrink
          disabled
          // size={gridSizeMdLg6}
        />
      </>
    </>
  );
};

export default ClienteFibraSummaryTFormab;
